<app-auth-header></app-auth-header>
<main class="auth-main">
  <router-outlet></router-outlet>
</main>
<app-feedback-widget></app-feedback-widget>